export type TooltipPosition = "top" | "bottom" | "left" | "right";
export type TooltipTargetType = "toolbar" | "toolbox" | "map-float";

export interface TooltipDefinition {
  id: string;
  content: string;
  position: TooltipPosition;
  targetType: TooltipTargetType;
}

export const TOOLTIPS: Record<string, TooltipDefinition> = {
  "gps-upload": {
    id: "gps-upload",
    content: "Add GPS data to your map to show your route",
    position: "right",
    targetType: "toolbar",
  },
  "static-labels": {
    id: "static-labels",
    content: "Edit titles and add trail stats to your map",
    position: "right",
    targetType: "toolbar",
  },
  "map-labels": {
    id: "map-labels",
    content: "Click anywhere on your route to add a map label",
    position: "left",
    targetType: "map-float",
  },
};

// Maximum number of times each tooltip will be shown before being permanently dismissed
export const MAX_TOOLTIP_SHOWS = 3;

// localStorage key for persisting tooltip state
export const TOOLTIP_STORAGE_KEY = "trailart_tooltip_state";

// Reset all tooltip dismiss counts (clears localStorage)
export function resetTooltips(): void {
  try {
    localStorage.removeItem(TOOLTIP_STORAGE_KEY);
  } catch (e) {
    console.warn("Failed to reset tooltip state:", e);
  }
}
